"use client";

import { PreviewServiceBlock } from "@/payload-types";
import Service from "../ProductService/Card/Service";
import RichText from "./LocalityRichText";
import { useLocalityService } from '@/providers/Locality';
import { usePathname } from "next/navigation";
import clsx from "clsx";
import Link from "next/link";

const LocalityServices: React.FC<PreviewServiceBlock> = (data) => {
  const pathname = usePathname();
  const localityService = useLocalityService();
  const { selectedPages, title, richText } = data;

  return (
    localityService && (
      <div className="mx-auto max-w-7xl items-center px-4 py-10 sm:px-6 lg:px-8">
        <div>
          <div className="flex items-center justify-between xsmall:flex-col md:flex-row">
            {title && (
              <h1 className="max-w-3xl font-bold tracking-tight text-gray-900 sm:text-2xl md:text-3xl">
                {localityService.replaceTags(title)}
              </h1>
            )}
            <div
              className={clsx(
                "flex items-center justify-center gap-x-6 xsmall:py-3 md:py-0",
              )}
            >
              <Link
                href={`/${pathname.split("/")[1]}`}
                className="rounded-md bg-[#0079AD] px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#005E87] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 xsmall:text-center lg:text-left"
              >
                En savoir plus
              </Link>
            </div>
          </div>
          {richText && (
            <div className="mt-4 max-w-3xl ">
              <RichText data={richText} className="text-gray-500" />
            </div>
          )}
        </div>
        <dl className="col-span-2 mt-4 grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2">
          {selectedPages &&
            selectedPages.map((service) => (
              <Service key={service.id} service={service} />
            ))}
        </dl>
      </div>
    )
  );
};

export { LocalityServices };
